import ReportDocumento from 'components/core/ReportDocumento';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { gerarGuiaSadtIamspePdf } from 'services/guiaSadt';
import { generateRequisicaoPdf } from './generateRequisicaoPdf';

export default function ReportRequisicao() {
  const location = useLocation();
  const { requisicao, layout = 'padrao', medico } = location.state || {};
  const iamspe = layout === 'iamspe';
  const nomePaciente = requisicao?.NOMEPAC || 'Paciente';

  const gerarBlob = useCallback(() => {
    if (iamspe) return gerarGuiaSadtIamspePdf({ requisicao });
    return generateRequisicaoPdf({ requisicao });
  }, [iamspe, requisicao]);

  const fileName = iamspe
    ? `Guia-SADT-IAMSPE-${nomePaciente}-${Date.now()}.pdf`
    : `Requisicao-Timbrado-Prevencor-${nomePaciente}-${Date.now()}.pdf`;

  return (
    <ReportDocumento
      documento={requisicao}
      gerarBlob={gerarBlob}
      fileName={fileName}
      titulo={iamspe ? 'Relatório da Guia SADT' : 'Relatório da Requisição'}
      nomePaciente={nomePaciente}
      iframeTitle={iamspe ? 'Guia SADT IAMSPE' : 'Requisição Prevencor'}
      emptyMessage="Nenhuma requisição carregada."
      erroGeracao={
        iamspe ? 'Erro ao gerar o PDF da guia SADT.' : 'Erro ao gerar o PDF da requisição.'
      }
      sucessoMobile={iamspe ? 'Guia SADT gerada com sucesso!' : 'Requisição gerada com sucesso!'}
      alertaTitulo={
        iamspe ? '⚠️ Confira a guia SADT antes do envio' : '⚠️ Confira a requisição antes do envio'
      }
      alertaCorpo={
        iamspe ? (
          <>
            Visualize cuidadosamente o PDF e confirme se os dados do paciente e a guia SADT estão
            corretos. <br />
            Após a conferência, utilize o botão abaixo para enviar a guia pelo WhatsApp:
            <strong> "Enviar pelo WhatsApp"</strong>.<br /> Lembre-se de que, uma vez enviado, não
            será possível desfazer a ação.
          </>
        ) : (
          <>
            Visualize cuidadosamente o PDF e confirme se os dados do paciente e os exames
            solicitados estão corretos. <br />
            Após a conferência, utilize o botão abaixo para enviar a requisição pelo WhatsApp:
            <strong> "Enviar pelo WhatsApp"</strong>.<br /> Lembre-se de que, uma vez enviado, não
            será possível desfazer a ação.
          </>
        )
      }
      whatsapp={{
        celular: requisicao?.CELULARPAC,
        paciente: {
          id: requisicao?.CODPAC,
          nome: nomePaciente,
          medico: medico?.apelido,
        },
        codLaudo: requisicao?.CODREQUISICAO,
        fileName: iamspe
          ? `Guia-SADT-IAMSPE_${requisicao?.CODREQUISICAO || Date.now()}.pdf`
          : `Requisicao_${requisicao?.CODREQUISICAO}.pdf`,
        caption: iamspe
          ? `Olá *${nomePaciente}*, tudo bem? 😊\n\nSegue em anexo a sua *Guia SADT IAMSPE*.\n\nQualquer dúvida, nossa equipe estará à disposição no setor de atendimento: (14) 3402-2700`
          : `Olá *${nomePaciente}*, tudo bem? 😊\n\nSegue em anexo a sua *Requisição de Exames*.\n\nQualquer dúvida, nossa equipe estará à disposição no setor de atendimento: (14) 3402-2700`,
      }}
    />
  );
}
